var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { SelfService } from '../../bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LandingPaginationDTO } from "../../bpg-common/services/data.services";
import { ConstantValues } from '../../bpg-common/models/bpg-constants';
import { Router } from '@angular/router';
import { BpgCommonService } from '../../bpg-common/services/bpg-common.service';
import { BpgEventsService } from '../../bpg-events/bpg-events.service';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { DatePipe } from '@angular/common';
import { UploadService } from './../d-i/upload.service';
var ConfigureGalleryComponent = /** @class */ (function () {
    function ConfigureGalleryComponent(userService, spinner, bpgCommonService, bpgEventsService, router, environment, datePipe, uploadService) {
        this.userService = userService;
        this.spinner = spinner;
        this.bpgCommonService = bpgCommonService;
        this.bpgEventsService = bpgEventsService;
        this.router = router;
        this.environment = environment;
        this.datePipe = datePipe;
        this.uploadService = uploadService;
        this.LandingPaginationDTO = new LandingPaginationDTO();
        this.user = null;
        this.role = null;
        this.roleName = null;
        this.userFirstName = null;
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.createdBy = this.loginData.userId;
        this.modifiedBy = this.loginData.userId;
        this.userId = this.loginData['userId'];
        this.adminId = localStorage.getItem('adminId');
        this.currentPage = 0;
        this.currentNumberOfElements = 16;
        this.totalPages = 0;
        this.limit = 16;
        this.currentShowingElements = 16;
        this.selectedSiteId = Number(localStorage.getItem('userSiteId'));
        this.loginUserAdminId = localStorage.getItem('adminId');
        this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
        this.eventPicture = true;
        this.uploadFileName = null;
        this.uploadFileExtension = false;
        this.uploadedFile = null;
        this.action = "";
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.selectedFile = null;
        this.uploadConstant = "Upload < 500MB";
        this.selectedFileName = this.uploadConstant;
        this.fileName = "";
        this.fileSize = 0;
        this.fileList = [];
        this.fileListName = [];
        this.selectedSiteIdSearch = 0;
        this.selectedErgIdSearch = 0;
        this.page = 0;
        this.isFileUploded = false;
        this.galleryItemsList = null;
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.uploadFlag = "gallery";
        this.errorMsgUploadSave = false;
        this.leadAdminId = localStorage.getItem('leadAdminId');
        this.allowedExtensions = ["xls", "xlsx", "doc", "docx", "txt", "pdf"];
        this.selectAllConstant = 'Select All';
        this.typeList = [{ type: this.selectAllConstant }, { type: 'Image' }, { type: 'Video' }];
        this.isbpgAdmin = false;
        this.isbpgLeadAdmin = false;
    }
    ConfigureGalleryComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        if (localStorage.getItem('logOutFlag') === "true") {
            this.router.navigate(['/log-out']);
        }
        this.loginDataDetails = JSON.parse(localStorage.getItem('loginData'));
        localStorage.removeItem('searchedEventsCaledarItems');
        this.bpgCommonService.getSessionToken();
        this.spinner.show();
        this.logUserAction();
        if (localStorage.getItem('isbpgAdmin') === 'true') {
            this.isbpgAdmin = true;
        }
        if (localStorage.getItem('isbpgLeadAdmin') === 'true') {
            this.isbpgLeadAdmin = true;
        }
        sessionStorage.removeItem("MembershipData");
        if (this.leadAdminId === 'true' && !this.isbpgAdmin) {
            localStorage.setItem('adminId', '2');
        }
        this.userAndRoleIdDTO = {
            userId: this.loginDataDetails['userId'],
            roleId: localStorage.getItem('adminId')
        };
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
            this.bpgEventsService.getChapterDropDown(this.userAndRoleIdDTO).subscribe(function (data) {
                _this.chapterList = data;
                if (_this.chapterList.length > 1) {
                    _this.chapterList.unshift({ chapterId: 0, siteName: _this.selectAllConstant, bpgName: '' });
                }
                for (var i = 0; i < _this.chapterList.length; i++) {
                    if (i === 0) {
                        _this.chapterIds = _this.chapterList[i].chapterId;
                    }
                    else {
                        _this.chapterIds = _this.chapterIds + "," + _this.chapterList[i].chapterId;
                    }
                }
                _this.siteData = {
                    "filter": {
                        chapterId: _this.chapterIds
                    },
                    "moduleId": 0,
                    "page": 0,
                    "presentRole": "",
                    "searchTerm": "",
                    "size": 0,
                    "sortDirection": "ASC",
                    "sortProperty": "",
                    "uid": ""
                };
                _this.bpgCommonService.getSiteList(_this.siteData).subscribe(function (data) {
                    _this.siteList = data;
                    _this.siteListSearch = data;
                    //filter default site from sitelist
                    _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
                    _this.siteListSearch = _this.siteListSearch.filter(function (site) { return site.locationCode !== 'DFLT'; });
                    _this.siteListSearch.unshift({ siteId: 0, siteName: _this.selectAllConstant, bpgName: '' });
                    for (var i = 0; i < _this.siteList.length; i++) {
                        if (i === 0) {
                            _this.allSiteIds = _this.siteList[i].siteId;
                        }
                        else {
                            _this.allSiteIds = "" + _this.allSiteIds + _this.siteList[i].siteId + ",";
                        }
                    }
                    for (var i = 0; i < _this.siteListSearch.length; i++) {
                        if (i === 0) {
                            _this.allSiteIds = _this.siteListSearch[i].siteId;
                        }
                        else {
                            _this.allSiteIds = "" + _this.allSiteIds + _this.siteListSearch[i].siteId + ",";
                        }
                    }
                    _this.getBpgList();
                    _this.getBpgListSearch();
                });
            });
            this.getSiteName();
        }
        else if (this.loginUserAdminId === "1") {
            this.getSiteName();
            this.getSiteList();
            this.getBpgList();
            this.getBpgListSearch();
            this.getChapterGalleryList();
        }
        this.landingDto = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.loginUserId = this.loginData.userId;
        setTimeout(function () {
            this.spinner.hide();
        }.bind(this), 500);
    };
    /** get site name in the dropdown for lead admin
      * @class ConfigureGalleryComponent
      * @method getSiteName
      */
    ConfigureGalleryComponent.prototype.getSiteName = function () {
        this.selectedSite = this.loginData.site.siteName;
    };
    /** get site list in the dropdown
      * @class ConfigureGalleryComponent
      * @method getSiteList
      */
    ConfigureGalleryComponent.prototype.getSiteList = function () {
        var _this = this;
        this.siteData = {
            "filter": {},
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.bpgCommonService.getSiteList(this.siteData).subscribe(function (data) {
            _this.siteList = data;
            _this.siteListSearch = data;
            //filter default site from sitelist
            _this.siteList = _this.siteList.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteListSearch = _this.siteListSearch.filter(function (site) { return site.locationCode !== 'DFLT'; });
            _this.siteListSearch.unshift({ siteId: 0, siteName: _this.selectAllConstant, bpgName: '' });
            if (_this.siteList != null || _this.siteListSearch != null) {
                for (var _i = 0, _a = _this.siteList; _i < _a.length; _i++) {
                    var s = _a[_i];
                    if (s.siteId === _this.selectedSiteId) {
                        _this.selectedSite = s.siteName;
                    }
                }
                for (var _b = 0, _c = _this.siteListSearch; _b < _c.length; _b++) {
                    var s1 = _c[_b];
                    if (s1.siteId === _this.selectedSiteId) {
                        _this.selectedSite = s1.siteName;
                    }
                }
                for (var i = 0; i < _this.siteList.length; i++) {
                    if (i === 0) {
                        _this.allSiteIds = _this.siteList[i].siteId;
                    }
                    else {
                        _this.allSiteIds = "" + _this.allSiteIds + _this.siteList[i].siteId + ",";
                    }
                }
                for (var i = 0; i < _this.siteListSearch.length; i++) {
                    if (i === 0) {
                        _this.allSiteIds = _this.siteListSearch[i].siteId;
                    }
                    else {
                        _this.allSiteIds = "" + _this.allSiteIds + _this.siteListSearch[i].siteId + ",";
                    }
                }
            }
        });
    };
    /** get gallery list
     * @class ConfigureGalleryComponent
     * @method getChapterGalleryList
     */
    ConfigureGalleryComponent.prototype.getChapterGalleryList = function () {
        var _this = this;
        this.spinner.show();
        if (this.selectedSiteIdSearch === 0) {
            this.selectedSiteIdSearch = this.allSiteIds;
        }
        if (this.selectedErgIdSearch === 0) {
            this.selectedErgIdSearch = this.allBpgIds;
        }
        this.landingData = {
            "filter": { "siteId": this.selectedSiteIdSearch, "bpgId": this.selectedErgIdSearch, "type": this.filterType },
            "moduleId": 0,
            "page": this.page,
            "presentRole": "string",
            "searchTerm": "string",
            "size": this.limit,
            "sortDirection": "DESC",
            "sortProperty": "created_date_time",
            "uid": "string"
        };
        this.userService.getChapterGalleryList(this.landingData).subscribe(function (data) {
            _this.galleryItemsList = data.content;
            _this.numberOfElements = data.totalElements;
            _this.spinner.hide();
            if (_this.galleryItemsList.length === 0) {
                _this.noDataFound = true;
            }
            else {
                _this.noDataFound = false;
            }
        });
    };
    /** get bpg list in the dropdown
      * @class ConfigureGalleryComponent
      * @method getBpgList
      */
    ConfigureGalleryComponent.prototype.getBpgList = function () {
        var _this = this;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteId,
                    "adminId": this.loginUserAdminId,
                    "userId": this.createdBy
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "string",
                "searchTerm": "string",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "string",
                "uid": "string"
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgList = data;
            if (_this.bpgList.length === 0) {
                _this.bpgList.unshift({ bpgId: 0, bpgName: 'No Data found' });
            }
            if (_this.bpgList != null) {
                for (var _i = 0, _a = _this.bpgList; _i < _a.length; _i++) {
                    var bpg = _a[_i];
                    if (bpg.bpgId === _this.selectedErgId) {
                        _this.selectedBpg = bpg.bpgName;
                    }
                }
                for (var i = 0; i < _this.bpgList.length; i++) {
                    if (i === 0) {
                        _this.allBpgIds = _this.bpgList[i].bpgId;
                    }
                    else {
                        _this.allBpgIds = "" + _this.allBpgIds + _this.bpgList[i].bpgId + ",";
                    }
                }
            }
        });
    };
    ConfigureGalleryComponent.prototype.getBpgListSearch = function () {
        var _this = this;
        this.selectedBpgsData =
            {
                "filter": {
                    "siteId": this.selectedSiteIdSearch,
                    "adminId": this.loginUserAdminId,
                    "userId": this.createdBy
                },
                "moduleId": 0,
                "page": 0,
                "presentRole": "",
                "searchTerm": "",
                "size": 0,
                "sortDirection": "ASC",
                "sortProperty": "",
                "uid": ""
            };
        this.bpgCommonService.getMyBPGsList(this.selectedBpgsData).subscribe(function (data) {
            _this.bpgListSearch = data;
            if (_this.bpgListSearch != null) {
                _this.bpgListSearch.unshift({ bpgId: 0, bpgName: _this.selectAllConstant });
                for (var _i = 0, _a = _this.bpgListSearch; _i < _a.length; _i++) {
                    var b = _a[_i];
                    if (b.bpgId === _this.selectedErgId) {
                        _this.selectedBpg = b.bpgName;
                    }
                }
                for (var i = 0; i < _this.bpgListSearch.length; i++) {
                    if (i === 0) {
                        _this.allBpgIds = _this.bpgListSearch[i].bpgId;
                    }
                    else {
                        _this.allBpgIds = "" + _this.allBpgIds + _this.bpgListSearch[i].bpgId + ",";
                    }
                }
                if (_this.loginUserAdminId === "2" || _this.loginUserAdminId === "3" || _this.isbpgAdmin || _this.isbpgLeadAdmin) {
                    _this.getChapterGalleryList();
                }
            }
        });
    };
    /** get chapter id
    * @class ConfigureGalleryComponent
    * @method getChapterIds
    */
    ConfigureGalleryComponent.prototype.getChapterIds = function () {
        var _this = this;
        this.landingData = {
            "filter": {
                "bpgId": this.selectedErgId,
                "siteId": this.selectedSiteId
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "string",
            "searchTerm": "string",
            "size": 0,
            "sortDirection": "ASC",
            "sortProperty": "string",
            "uid": "string"
        };
        this.userService.getChapterByBpg(this.landingData).subscribe(function (data) {
            if (data != null) {
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var d = data_1[_i];
                    _this.chapterId = d;
                }
            }
        });
    };
    /** For site change from site list
       * @class ConfigureGalleryComponent
       * @method siteChange
       * @returns Promise
       */
    ConfigureGalleryComponent.prototype.siteChange = function (event) {
        this.selectedErgId = null;
        this.selectedBpg = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedSiteId = event.siteId;
        this.bpgList = [];
        this.getBpgList();
        this.getEventIdOnSelectOfSiteChapter();
        this.eventId = null;
    };
    /** For bpg change from bpg list
      * @class ConfigureGalleryComponent
      * @method bpgChange
      * @returns Promise
      */
    ConfigureGalleryComponent.prototype.bpgChange = function (event) {
        this.selectedErgId = null;
        this.userFirstName = null;
        this.userId = null;
        this.selectedErgId = event.bpgId;
        this.getChapterIds();
        this.getEventIdOnSelectOfSiteChapter();
        this.eventId = null;
    };
    ConfigureGalleryComponent.prototype.onFileSelected = function (event) {
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.selectedFileName = "";
        if (event.target.files.length > 0) {
            for (var i = 0; i < event.target.files.length; i++) {
                this.fileName = event.target.files[i].name.replace(/,/g, '-');
                this.fileSize += event.target.files[i].size;
                var allowedExtensions = ["jpeg", "png", "mp4", "jpg", "mov", "ogg"];
                this.fileExtension = this.fileName.split('.').pop();
                if (this.isInArray(allowedExtensions, this.fileExtension)) {
                    if (this.fileSize > 524288000) {
                        this.fileSizeExtensionError = true;
                    }
                    else {
                        this.fileExtensionError = false;
                        this.fileSizeExtensionError = false;
                        this.selectedFile = event.target.files[i];
                        this.fileList.push(this.selectedFile);
                        this.fileListName.push(this.selectedFile.name.replace(/,/g, '-'));
                        if (i === 0) {
                            this.selectedFileName = this.selectedFile.name.replace(/,/g, '-');
                        }
                        else {
                            this.selectedFileName = this.selectedFileName + " , " + this.selectedFile.name.replace(/,/g, '-');
                        }
                        this.isFileUploded = true;
                    }
                }
                else {
                    this.fileExtensionError = true;
                    this.selectedFileName = this.uploadConstant;
                }
            }
        }
    };
    /** checks if word exists in array
     * @class ConfigureGalleryComponent
     * @method isInArray
     */
    ConfigureGalleryComponent.prototype.isInArray = function (array, word) {
        return array.indexOf(word.toLowerCase()) > -1;
    };
    /** get event id's of site and chapter
      * @class ConfigureGalleryComponent
      * @method getEventIdOnSelectOfSiteChapter
      */
    ConfigureGalleryComponent.prototype.getEventIdOnSelectOfSiteChapter = function () {
        var _this = this;
        var fromDate = this.datePipe.transform(new Date, ConstantValues.dateFormats.dateFormat);
        var toDate = this.datePipe.transform(this.addDays(new Date, 365), ConstantValues.dateFormats.dateFormat);
        this.landingData = {
            "filter": {
                "siteId": this.selectedSiteId,
                "bpgId": this.selectedErgId,
                "fromDate": fromDate,
                "toDate": toDate,
                "title": "gallery"
            },
            "moduleId": 0,
            "page": 0,
            "presentRole": "",
            "searchTerm": "",
            "size": 500,
            "sortDirection": "DESC",
            "sortProperty": "event_create_date",
            "uid": ""
        };
        this.bpgEventsService.getAllEvents(this.landingData).subscribe(function (data) {
            _this.eventList = data.content;
        }, function (err) {
            if (err.value.statusText === ConstantValues.unknownError) {
                _this.timeOutError = true;
            }
        });
    };
    /** For adding 365 days to current day
  * @class ConfigureGalleryComponent
  * @method addDays
  * @params Date, number
  */
    ConfigureGalleryComponent.prototype.addDays = function (date, days) {
        date.setDate(date.getDate() + days);
        return date;
    };
    /** to submit resource
     * @class ConfigureGalleryComponent
     * @method onChapterGallerySubmit
     */
    ConfigureGalleryComponent.prototype.onChapterGallerySubmit = function () {
        this.method = "addGallery";
        this.param = '';
        this.msg1 = " Are you sure you want to save ? ";
    };
    /** to add new admin
      * @class ConfigureGalleryComponent
      * @method addGallery
      */
    ConfigureGalleryComponent.prototype.addGallery = function () {
        var _this = this;
        this.timeOutError = false;
        this.createdDateTime = new Date();
        this.modifiedDateTime = new Date();
        var galleryData = {
            "createdBy": this.createdBy,
            "createdDateTime": this.createdDateTime,
            "isActive": true,
            "modifiedBy": this.modifiedBy,
            "modifiedDateTime": this.modifiedDateTime,
            "fileNameList": this.fileListName,
            "bpgId": this.selectedErgId,
            "isEvent": this.eventPicture,
            "siteId": this.selectedSiteId,
            "eventId": this.eventId,
            "uploadedDate": this.datePipe.transform(new Date(), 'yyyy-MM-dd'),
            "documentName": this.documentName
        };
        var uploadData = {
            'category': 'uploadDocument',
        };
        //if save condition
        this.action = "CHAPTER_GALLERY";
        this.spinner.show();
        this.userService.addGallery(galleryData).subscribe(function (data) {
            _this.galleryList = data;
            _this.galleryList.fileName = _this.galleryList.fileName.split(',');
            _this.galleryList.galleryId = _this.galleryList.galleryListId.split(',');
            if (data.message !== undefined) {
                _this.spinner.hide();
                setTimeout(function () {
                    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                }, 300);
            }
            else if (data !== undefined) {
                _this.spinner.show();
                var _loop_1 = function (i) {
                    _this.bpgCommonService.getAwsUrl(uploadData).subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                        var _this = this;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    this.awsUrls = data;
                                    return [4 /*yield*/, this.uploadService.getPresignedUrl(this.fileList[i], this.awsUrls, this.galleryList.fileName[i], this.uploadFlag)];
                                case 1:
                                    _a.sent();
                                    if (localStorage.getItem('uploadError') === 'Error') {
                                        this.userService.deleteGallery(this.galleryList.galleryId[i]).subscribe(function (_data) {
                                            _this.spinner.hide();
                                            _this.errorMsgUploadSave = true;
                                            _this.alertSuccess = false;
                                            _this.deleteSuccess = false;
                                            localStorage.removeItem('uploadError');
                                        });
                                    }
                                    else {
                                        this.alertSuccess = true;
                                        this.deleteSuccess = false;
                                        this.errorMsgUploadSave = false;
                                        this.getChapterGalleryList();
                                    }
                                    setTimeout(function () {
                                        window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                                    }, 200);
                                    this.spinner.hide();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, function (err) {
                        _this.spinner.hide();
                        if (err.value.statusText === ConstantValues.unknownError) {
                            _this.timeOutError = true;
                        }
                        setTimeout(function () {
                            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
                        }, 200);
                    });
                };
                for (var i = 0; i < _this.fileList.length; i++) {
                    _loop_1(i);
                }
            }
        });
    };
    /** For filtering data by current page
     * @class ConfigureGalleryComponent
     * @method pageChanged
     * @params event
     */
    ConfigureGalleryComponent.prototype.pageChanged = function (event) {
        this.page = event - 1;
        this.currentPage = event;
        if ((this.currentPage * this.limit) < this.numberOfElements) {
            this.currentShowingElements = this.currentPage * this.limit;
        }
        else if ((this.currentPage * this.limit) >= this.numberOfElements) {
            this.currentShowingElements = this.numberOfElements;
        }
        this.getChapterGalleryList();
    };
    /** Confirm on reset
      * @class ConfigureGalleryComponent
      * @method resetGallery
      */
    ConfigureGalleryComponent.prototype.resetGallery = function () {
        setTimeout(function () {
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        }, 200);
        this.myInputVariable.nativeElement.value = "";
        this.selectedBpg = null;
        this.selectedErgId = null;
        this.selectedErgIdSearch = null;
        this.selectedSiteIdSearch = null;
        this.searchKey = null;
        this.LandingPaginationDTO.searchTerm = null;
        this.selectedFileName = this.uploadConstant;
        this.selectedSiteId = localStorage.getItem('userSiteId');
        this.eventId = null;
        this.deleteSuccess = false;
        this.fileExtensionError = false;
        this.fileSizeExtensionError = false;
        this.alertSuccess = false;
        this.selectedFile = null;
        this.isFileUploded = false;
        this.selectedBpgSearch = null;
        this.selectedSiteSearch = null;
        this.errorMsgUploadSave = false;
        this.documentName = "";
        this.filterType = null;
        this.selectedSite = this.loginData.site.siteName;
        this.eventPicture = true;
        if (this.loginUserAdminId === "2" || this.loginUserAdminId === "3" || this.isbpgAdmin || this.isbpgLeadAdmin) {
            this.selectedSiteIdSearch = 0;
            this.selectedErgIdSearch = 0;
            this.getBpgListSearch();
        }
        this.getChapterGalleryList();
        this.getBpgList();
    };
    /** For site change from site list
     * @class ConfigureGalleryComponent
     * @method siteChangeSearch
     * @returns Promise
     */
    ConfigureGalleryComponent.prototype.siteChangeSearch = function (event) {
        this.selectedSiteIdSearch = event.siteId;
        this.getBpgListSearch();
    };
    /** For bpg change from bpg list
      * @class ConfigureGalleryComponent
      * @method bpgChangeSearch
      * @returns Promise
      */
    ConfigureGalleryComponent.prototype.bpgChangeSearch = function (event) {
        this.selectedErgIdSearch = event.bpgId;
    };
    /** to Delete gallery
* @class ConfigureGalleryComponent
* @method deleteGallery
*/
    ConfigureGalleryComponent.prototype.deleteGallery = function (galleryId) {
        var _this = this;
        this.spinner.show();
        this.userService.deleteGallery(galleryId).subscribe(function (_data) {
            _this.spinner.hide();
            window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
            _this.deleteSuccess = true;
            _this.alertSuccess = false;
            _this.errorMsgUploadSave = false;
            if (_this.galleryItemsList.length === 1 && _this.numberOfElements > 16) {
                _this.currentPage = 0;
                _this.page = 0;
                _this.currentShowingElements = 16;
            }
            _this.getChapterGalleryList();
        });
    };
    /** confirmation to delete gallery
  * @class ConfigureGalleryComponent
  * @method deleteGalleryConfirmation
  */
    ConfigureGalleryComponent.prototype.deleteGalleryConfirmation = function (id) {
        this.method = "deleteGallery";
        this.param = id;
        this.msg1 = "  Are you sure you want to delete ? ";
    };
    ConfigureGalleryComponent.prototype.downloadDocument = function (urls, i) {
        var extension = urls.substring(urls.lastIndexOf('.') + 1);
        var link = document.getElementById('downloadFiles' + i);
        link.setAttribute('href', urls);
        link.setAttribute('download', urls);
        if (extension.includes('mp4')) {
            link.setAttribute('target', '_blank');
        }
    };
    /** to reset resource
     * @class ConfigureGalleryComponent
     * @method resetClick
     */
    ConfigureGalleryComponent.prototype.resetClick = function () {
        this.method = "resetGallery";
        this.param = '';
        this.msg1 = " Your current changes will be discarded, do you want to continue ? ";
    };
    ConfigureGalleryComponent.prototype.getChapterGalleryListSearch = function () {
        this.page = 0;
        this.currentPage = 1;
        this.getChapterGalleryList();
    };
    ConfigureGalleryComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Configure Gallery Screen"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    return ConfigureGalleryComponent;
}());
export { ConfigureGalleryComponent };
